import { render, staticRenderFns } from "./StartseiteCRM.vue?vue&type=template&id=47379da9"
import script from "./StartseiteCRM.vue?vue&type=script&lang=js"
export * from "./StartseiteCRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports